import { Hammer, Paintbrush, Cog, Zap, Truck, Shield, Frame, Droplets, ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { SERVICES, waLink } from "@/data/content";

const ICONS = {
  kaporta: Hammer,
  boya: Paintbrush,
  mekanik: Cog,
  elektrik: Zap,
  mobil: Truck,
  gucuk: Shield,
  cam: Frame,
  plastik: Droplets,
  radyator: Cog,
};

export const Hizmetler = () => (
  <section id="hizmetler" className="scroll-mt-24 bg-white py-20 lg:py-28">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <div className="max-w-2xl">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-brand">Hizmetlerimiz</p>
          <h2 className="mt-3 font-display text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
            Aracınız için gereken her şey, tek çatı altında
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-slate-600">
            Kaportadan radyatöre; 1.026 m² kapalı atölyemizde 9 farklı alanda uzman hizmet.
          </p>
        </div>
      </Reveal>

      <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3 lg:gap-8">
        {SERVICES.map((s, i) => {
          const Icon = ICONS[s.key] || Cog;
          return (
            <Reveal key={s.key} delay={(i % 3) * 0.08}>
              <a
                href={waLink(`Merhaba Sistemli Otomotiv, ${s.title} hizmeti hakkında bilgi ve fiyat almak istiyorum.`)}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`service-card-${s.key}`}
                className="group flex h-full flex-col rounded-2xl border border-slate-200 bg-white p-6 shadow-soft transition-all duration-300 hover:-translate-y-1.5 hover:border-brand/50 hover:shadow-lift sm:p-8"
              >
                <div className="flex items-start justify-between">
                  <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-brand-softer text-brand transition-colors duration-300 group-hover:bg-brand group-hover:text-white">
                    <Icon className="h-6 w-6" strokeWidth={2.2} />
                  </span>
                  <span className="rounded-full bg-slate-50 px-3 py-1 text-[11px] font-bold uppercase tracking-wide text-slate-500 ring-1 ring-slate-200">
                    {s.badge}
                  </span>
                </div>
                <h3 className="mt-5 font-display text-xl font-bold text-slate-900">{s.title}</h3>
                <p className="mt-2.5 flex-1 text-sm leading-relaxed text-slate-600">{s.desc}</p>
                <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-bold text-brand">
                  WhatsApp'tan sor
                  <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
                </span>
              </a>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);

export default Hizmetler;
